import { normalizeRoleKey } from './organizationRoleUtils';

/**
 * Parse les messages transaction-listener (même logique que mobile WaitingPaymentScreen).
 */
export function cleanAndParseJson(badJsonString) {
    if (badJsonString == null || typeof badJsonString !== 'string') return null;
    try {
        let fixed = badJsonString
            .replace(/([{,]\s*)([a-zA-Z0-9_]+)\s*:/g, '$1"$2":')
            .replace(/:\s*([a-zA-Z_][a-zA-Z0-9_]*)/g, ': "$1"')
            .replace(/'/g, '"');
        return JSON.parse(fixed);
    } catch {
        return null;
    }
}

function tryParseJson(raw) {
    if (raw == null) return null;
    if (typeof raw === 'object') return raw;
    if (typeof raw !== 'string') return null;
    const cleaned = cleanAndParseJson(raw);
    if (cleaned) return cleaned;
    try {
        return JSON.parse(raw);
    } catch {
        return null;
    }
}

export function parseTransactionListenerMessage(messageBody) {
    let data = tryParseJson(messageBody);
    if (!data) return null;

    for (let depth = 0; depth < 4; depth += 1) {
        if (data?.ref != null || data?.status != null) return data;
        if (data?.body == null) break;
        const inner = tryParseJson(data.body);
        if (!inner || typeof inner !== 'object') break;
        data = inner;
    }

    return data?.ref != null || data?.status != null ? data : data;
}

/** ID STOMP : admin = org.id, caissier = user.id (comme mobile, via selectedRole). */
export function getTransactionListenerId(selectedOrganization, user) {
    if (!user?.id || !selectedOrganization?.id) return null;
    const storedRole =
        typeof localStorage !== 'undefined'
            ? localStorage.getItem('netikash_selected_role')
            : null;
    const role = normalizeRoleKey(
        selectedOrganization.selectedRole || storedRole || selectedOrganization.role
    );
    return role === 'admin' ? selectedOrganization.id : user.id;
}

export function extractListenerRef(body) {
    if (!body || typeof body !== 'object') return null;
    return (
        body.ref ??
        body.request_id ??
        body.target_id ??
        body.payment_request_id ??
        null
    );
}

export function isPaymentApprovedStatus(status) {
    const s = String(status || '').toLowerCase();
    return (
        s === 'approved' ||
        s === 'completed' ||
        s === 'paid' ||
        s === 'cashed' ||
        s === 'collected'
    );
}

export function matchesPaymentRequestRef(messageRef, requestId) {
    if (messageRef == null || requestId == null) return false;
    return String(messageRef).trim().toLowerCase() === String(requestId).trim().toLowerCase();
}
